<ion-header class="ion-no-border">
  <ion-toolbar color="light" class="ion-no-border">
    <ion-buttons slot="start">
      <ion-button (click)="return()">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button color="secondary" class="bordered" (click)="share()">
        <ion-icon color="primary" name="share-social"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>



<ion-content fullscreen="true" slot="fixed">

  <div class="contentHeader">
    <div  class="specialImgCard">
      <img class="specialImg"  [defaultImage]="assetLinksService.noImage" [lazyLoad]="shop.banner" [errorImage]="assetLinksService.noImage" onerror="this.src='assets/errorimg_ink.png'">
    </div>
  </div>
  <span style="position: absolute;
  top: 4em;
  left: 50%;
  z-index: 1;
  text-align: center;
  transform: translate(-50%, 0px);">
    <ion-avatar style="width: 9em;
    height: 9em;
    border: 0.2em solid var(--ion-color-dark);">
      <img  [defaultImage]="assetLinksService.avatarLoading" [lazyLoad]="shop.logo" [errorImage]="assetLinksService.noImage" onerror="this.src='assets/errorimg_ink.png'">
    </ion-avatar>
  </span>


  <ion-card #content class="outlet-details-card">
    <ion-card-header class="outlet-details-card-header">
      <ion-grid class="outlet-details-card-header-grid" fixed>
        <ion-row >
            <ng-container *ngIf="shop.name">
              <ion-col class="outlet-details-card-header-grid-left" size="12">
              <ion-card-title>
                <h2>{{shop.name}} </h2>
              </ion-card-title>
            </ion-col >
            </ng-container>
            <ng-container *ngIf="!shop.name">
              <ion-col class="outlet-details-card-header-grid-left" size="12">
              <ion-card-title >
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text> 
              </ion-card-title>
              <ion-card-subtitle>
                <ion-skeleton-text animated style="width: 70%"></ion-skeleton-text>
                <ion-skeleton-text animated style="width: 50%"></ion-skeleton-text>
              </ion-card-subtitle>
            </ion-col >
        
            </ng-container>
            
        </ion-row>
      </ion-grid>
    </ion-card-header>

    <ion-grid style="text-align: center;">
      <ion-row>
        <ion-col>
          <ion-button class="contactInfoButtons" (click)="call()">
            <ion-icon name="call-outline"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button (click)="sendMail()" class="contactInfoButtons">
            <ion-icon name="mail-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.whatsapp" class="contactInfoButtons" (click)="openWhatsapp()">
            <ion-icon name="logo-whatsapp"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.facebook" class="contactInfoButtons" (click)="openFacebookPage()">
            <ion-icon name="logo-facebook"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.instagram" class="contactInfoButtons" (click)="openInstaPage()">
            <ion-icon name="logo-instagram"></ion-icon>
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button [disabled]="!shop || !shop.website" class="contactInfoButtons" (click)="openWebsite()">
            <ion-icon name="globe-outline"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  
  </ion-card>



  <ion-toolbar   *ngIf="shopOutlets && shopOutlets.length>0">
    <ion-item  mode="ios">
      <ion-thumbnail style="margin: 0.5em;padding: 0.4em;">
        <img [src]="assetLinksService.store" />
      </ion-thumbnail>
      <ion-label  >
        <h2>Outlets</h2>
        <p>The merchant's various outlets on YumDealz - you can visit any of these to earn stamps</p>
      </ion-label>
     </ion-item>
     <swiper 
     #swiper 
     [config]="outletSwiperConfig"
     (swiper)="onSwiper($event)"
     (beforeTransitionStart)="onBeforeTransitionStart($event)">
       <ng-template swiperSlide *ngFor="let outlet of shopOutlets;" >
        <app-outlet-lane-card 
        [cardHeight]="'15em'"
        [outlet]="outlet"
        >
        </app-outlet-lane-card>
       </ng-template>
   </swiper>
   
  </ion-toolbar>

</ion-content>
